import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, AlertTriangle, FileWarning, Megaphone, StickyNote, ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { NOTIF_TYPES, fmtDateTime } from "@/lib/util";
import { BackBar, Loader, Empty, FileButton } from "@/components/common";
import Modal from "@/components/Modal";
import { tr as t, Auto, useAuto } from "@/lib/i18n";

const ICONS = { violation: AlertTriangle, document_alert: FileWarning, general: Megaphone, admin_note: StickyNote };

function NoteModal({ n, onClose }) {
  const title = useAuto(n?.title);
  return (
    <Modal open={!!n} onClose={onClose} title={title} testid="notification-modal">
      {n && (
        <div className="space-y-4">
          <div className="text-sm text-slate-500">{t(NOTIF_TYPES[n.type] || "")} • {fmtDateTime(n.created_at)}</div>
          <p className="text-lg whitespace-pre-wrap" data-testid="notification-body"><Auto text={n.body} /></p>
          <FileButton fileId={n.file_id} testid="notification-attachment-btn" className="btn btn-md btn-ghost w-full" />
          {n.violation_id && <Link data-testid="open-violation-btn" to={`/driver/violations/${n.violation_id}`} className="btn btn-lg btn-red w-full">{t("عرض المخالفة والرد")}</Link>}
        </div>
      )}
    </Modal>
  );
}

export default function MyNotifications() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/my/notifications").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const view = async (n) => {
    setOpen(n);
    if (!n.read_at) {
      await api.post(`/my/notifications/${n.rid}/read`).catch(() => {});
      setItems((xs) => xs.map((x) => (x.rid === n.rid ? { ...x, read_at: new Date().toISOString() } : x)));
    }
  };

  return (
    <div>
      <BackBar title={t("إشعاراتي")} to="/driver" />
      <div className="p-4 space-y-3">
        {items === null ? <Loader /> : items.length === 0 ? <Empty icon={Bell} text={t("لا توجد إشعارات")} /> : items.map((n) => {
          const Icon = ICONS[n.type] || Bell;
          return (
            <button key={n.rid} data-testid={`notification-${n.rid}`} onClick={() => view(n)}
              className={`card w-full p-4 flex gap-4 items-center text-start ${!n.read_at ? "border-2 border-red-300 bg-red-50/40" : ""}`}>
              <span className="w-14 h-14 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center shrink-0"><Icon className="w-8 h-8" /></span>
              <span className="flex-1 min-w-0">
                <span className="flex items-center gap-2"><b className="text-lg truncate"><Auto text={n.title} /></b>{!n.read_at && <span className="w-3 h-3 rounded-full bg-red-600 shrink-0" />}</span>
                <span className="block text-sm text-slate-500">{t(NOTIF_TYPES[n.type] || "")} • {fmtDateTime(n.created_at)}</span>
              </span>
              <ChevronLeft className="w-6 h-6 text-slate-400 ltr:rotate-180" />
            </button>
          );
        })}
      </div>
      <NoteModal n={open} onClose={() => setOpen(null)} />
    </div>
  );
}
